module.exports = __webpack_public_path__ + "static/media/cgpower.5240420d.svg";